module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sorry":"Sorry,","no_result":"This query gave not motaching content.","go_back_home":"Back to home page","nothing":"There is nothing here, but one day there will"},"fr":{"sorry":"Désolé,","no_result":"Cette recherche ne donne aucun résultat.","go_back_home":"Retourner à la page d\u0027accueil","nothing":"Il n\u0027y a rien ici, mais ça va venir"}}')
  delete Component.options._Ctor
}
